import React  from 'react';
import { AbsoluteFill, OffthreadVideo, useCurrentFrame } from 'remotion';
import { Layer, ProjectState } from "../../shared";

type Props = { 
    layer: Layer,
    project: ProjectState
};

function VideoLayer({ layer }: Props) {
    const { 
        blendMode, 
        opacity,
        visible,
        url, 
        startFrame,
        endFrame,
        rotation,
    } = layer;
    const frame = useCurrentFrame();
    const isVisible = visible && frame >= startFrame && frame <= endFrame;
    const { x, y } = layer.position;
    const { width, height } = layer.dimensions;

    if (!url) return null;

    if (!isVisible) {
        return null;
    }

    let filter = "";
    if (layer.adjustments && isVisible) {
        const { 
            brightnessContrast
        } = layer.adjustments;
        if (brightnessContrast) {
            const {
                brightness,
                contrast
            } = brightnessContrast;
            filter = `${filter} brightness(${brightness + 1})`;
            filter = `${filter} contrast(${contrast + 1})`;
        }
    }
    let transform = '';
    if (rotation && isVisible) {
        transform = `${transform} rotate(${rotation}deg)`;
    }
    return (
        <>
            <AbsoluteFill>
                <OffthreadVideo
                    style={{
                        position: 'absolute',
                        top: y || 0,
                        left: x || 0,
                        width,
                        height,
                        opacity: isVisible ? opacity : 0,
                        mixBlendMode: blendMode,
                        filter,
                        transform
                    }}
                    src={url}
                />
            </AbsoluteFill>
        </>
    )
}


export default VideoLayer;
